import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const { t, lang } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", {
        email: email.trim().toLowerCase(),
        lang,
      });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Klaida");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16" data-testid="forgot-password-page">
      {!sent ? (
        <>
          <h1 className="text-4xl sm:text-5xl font-heading font-black tracking-tight text-[#1A1A18]">
            {t("forgot_password_title")}
          </h1>
          <p className="mt-3 text-base text-[#4A4A45]">{t("forgot_password_sub")}</p>

          <form onSubmit={onSubmit} className="mt-8 space-y-3" data-testid="forgot-password-form">
            <div className="relative">
              <Mail className="absolute left-3 top-3.5 w-4 h-4 text-[#7A7A73]" />
              <input
                data-testid="forgot-password-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t("forgot_password_email_label")}
                required
                autoComplete="email"
                className="w-full pl-10 bg-white border border-[#D1CFC7] rounded-md px-4 py-3 outline-none focus:ring-2 focus:ring-[#C85A32]"
              />
            </div>
            <button
              type="submit"
              data-testid="forgot-password-submit"
              disabled={busy}
              className="btn-primary w-full disabled:opacity-60"
            >
              {busy ? "..." : t("forgot_password_submit")}
            </button>
            <Link
              to="/"
              data-testid="forgot-password-back"
              className="block text-center text-sm text-[#7A7A73] hover:text-[#C85A32] pt-2 inline-flex items-center justify-center gap-1.5 w-full"
            >
              <ArrowLeft className="w-3.5 h-3.5" /> {t("forgot_password_back")}
            </Link>
          </form>
        </>
      ) : (
        <div className="text-center py-8" data-testid="forgot-password-sent">
          <CheckCircle2 className="w-16 h-16 text-[#2A5C38] mx-auto" />
          <h1 className="mt-6 text-3xl font-heading font-black text-[#1A1A18]">
            {t("forgot_password_sent_title")}
          </h1>
          <p className="mt-3 text-base text-[#4A4A45]">{t("forgot_password_sent_sub")}</p>
          <Link
            to="/"
            data-testid="forgot-password-sent-back"
            className="mt-8 btn-primary inline-flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" /> {t("forgot_password_back")}
          </Link>
        </div>
      )}
    </div>
  );
}
